import { get, post, patch, del } from './client.js';

/* Notes are workspace-flat: filtered by personId / companyId as query params */
export const list = (wsId, params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`/workspaces/${wsId}/notes${q}`);
};

export const create = (wsId, body) => post(`/workspaces/${wsId}/notes`, body);

export const update = (wsId, noteId, body) => patch(`/workspaces/${wsId}/notes/${noteId}`, body);

export const remove = (wsId, noteId) => del(`/workspaces/${wsId}/notes/${noteId}`);

const _relTime = (iso) => {
  if (!iso) return 'just now';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60000)     return 'just now';
  if (ms < 3600000)   return Math.floor(ms / 60000) + 'm ago';
  if (ms < 86400000)  return Math.floor(ms / 3600000) + 'h ago';
  if (ms < 172800000) return 'yesterday';
  return new Date(iso).toLocaleDateString('en-IN');
};

export const normNote = (n) => ({
  id:          n.id,
  type:        'note',
  who:         n.author    || 'You',
  what:        'added a note',
  detail:      n.body      || '',
  noteTitle:   n.title     || '',
  time:        _relTime(n.createdAt),
  createdAt:   n.createdAt || null,
  updatedAt:   n.updatedAt || null,
  personId:    n.personId  || null,
  companyId:   n.companyId || null,
  dealId:      n.dealId    || null,
  attachments: Array.isArray(n.documents) ? n.documents.map(d => ({
    id:          d.id,
    fileName:    d.fileName,
    mimeType:    d.mimeType  || 'application/octet-stream',
    fileSize:    d.fileSize  || 0,
    downloadUrl: d.downloadUrl || null,
    createdAt:   d.createdAt  || null,
    status:      'uploaded',
  })) : [],
});
